<template>
  <div class="adjudicate">
    <Row class="detail-header">
      <span>{{ processCode=="JT_BB"?"判决":"二审判决" }}</span>
      <Button
        v-if="infoCtrl&&isDetailLoad" class="add-btn"
        type="primary" @click="infoCtrl=false"
      >修改</Button>
    </Row>
    <Row class="case-content">
      <Row class="flex-class" v-if="!infoCtrl&&isDetailLoad">
        <Form
          ref="formData" class="case-form"
          :model="formData" :rules="ruleValidate"
          :label-width="100"
        >
          <FormItem label="判决时间" prop="judgmentDate">
            <DatePicker
              transfer
              type="date"
              placeholder="请选择判决时间"
              style="width:100%"
              format="yyyy-MM-dd"
              :value="formData.judgmentDate"
              @on-change="getTime($event,'judgmentDate')"
            />
          </FormItem>
          <FormItem label="签收时间" prop="signDate">
            <DatePicker
              transfer
              type="date"
              placeholder="请选择签收时间"
              style="width:100%"
              format="yyyy-MM-dd"
              :value="formData.signDate"
              @on-change="getTime($event,'signDate')"
            />
          </FormItem>
          <FormItem label="判决机构" prop="agency">
            <!-- <Input v-model="formData.agency" placeholder="请输入判决机构"></Input> -->
            <span>{{ formData.agency }}</span>
          </FormItem>
          <FormItem label="判决摘录" prop="remark">
            <Input
              v-model.trim="formData.remark" type="textarea"
              :autosize="{minRows: 3,maxRows: 8}" placeholder="请输入判决摘录(不超过512个字符)"
            />
          </FormItem>
          <FormItem label="判决结果" prop="result">
            <RadioGroup v-model="formData.result">
              <Radio :label="1">判刑</Radio>
              <Radio :label="0">无罪释放</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="判决书" prop="attachmentList">
            <file-upload
              :default-list="defaultList || []"
              :upload-config="{}"
              @getFileList="getAttachmentList"
            />
          </FormItem>
        </Form>
        <Row class="detail-btn-box">
          <Button
            type="primary" style="margin-right:10px;"
            :disabled="isSubmit" @click="submitNew"
          >保存</Button>
          <Button v-if="defaultData" @click="infoCtrl=true">取消</Button>
        </Row>
      </Row>
      <Row v-if="infoCtrl&&isDetailLoad" class="detail-content flex-class">
        <Row><Col span="5" class="left-label">判决时间：</Col><Col span="16" class="right-content">{{ defaultData.judgmentDate }}</Col></Row>
        <Row><Col span="5" class="left-label">签收时间：</Col><Col span="16" class="right-content">{{ defaultData.signDate }}</Col></Row>
        <Row><Col span="5" class="left-label">判决机构：</Col><Col span="16" class="right-content">{{ defaultData.agency }}</Col></Row>
        <Row><Col span="5" class="left-label">判决摘录：</Col><Col span="16" class="right-content">{{ defaultData.remark }}</Col></Row>
        <Row><Col span="5" class="left-label">判决结果：</Col><Col span="16" class="right-content">{{ defaultData.result?"判刑":"无罪释放" }}</Col></Row>
        <Row>
          <Col span="5" class="left-label">判决书：</Col>
          <Col span="16" class="right-content">
            <file-upload
              :default-list="defaultData.attachmentList || []"
              :upload-config="{readOnly:true}"
            />
          </Col>
        </Row>
      </Row>
      <judge-result
        v-if="isJudgeResult" :process-id="processId"
        :judge-type="judgeType"
        @reloadProcess="$emit('reloadProcess')"
      />
    </Row>
  </div>
</template>
<script>
import JudgeResult from '@/view/civilCase/adjudicate/judgeResult.vue'
export default {
  components: {
    JudgeResult
  },
  props: ['processId', 'caseId', 'processCode', 'isJudgeResult', 'judgeType'],
  data () {
    return {
      isDetailLoad: false,
      infoCtrl: true,
      isSubmit: false,
      defaultData: '',
      defaultList: [],
      litigantIdArr: [],
      formData: {
        judgmentDate: '',
        signDate: '',
        agency: '',
        remark: '',
        result: 1,
        attachmentList: []
      },
      ruleValidate: {
        judgmentDate: [{ required: true, message: '判决时间不能为空', trigger: 'blur' }],
        agency: [{ required: true, message: '判决机构不能为空', trigger: 'blur' }],
        remark: [{ required: true, message: '判决摘录不能为空', trigger: 'blur' }],
        result: [{ required: true, type: 'number', message: '判决结果不能为空', trigger: 'blur' }],
        attachmentList: [{ required: true, type: 'array', message: '判决书不能为空', trigger: 'blur' }]
      }
    }
  },
  watch: {},
  created() {},
  beforeMount() {
    this.getFillingCourt()
  },
  mounted() {
    this.getDetail()
  },
  updated() {},
  methods: {
    getDetail() {
      const url = '/business/case/criminal/judgment?processId=' + this.processId
      this.$get(url).then(res => {
        if (res.code == 0 && res.data) {
          this.defaultData = res.data
          this.infoCtrl = true
          this.giveDefaultData()
        } else {
          this.defaultData = ''
          this.infoCtrl = false
          this.isDetailLoad = true
        }
      })
    },
    getTime(value, key) {
      this.formData[key] = value
    },
    getFillingCourt() {
      const url = '/business/case/criminal/review-prosecution/court?caseId=' + this.caseId
      this.$get(url).then(res => {
        if (res.code == 0) {
          this.formData.agency = res.data || ''
        }
      })
    },
    getAttachmentList(arr) {
      this.formData.attachmentList = []
      arr.forEach((item, index) => {
        const obj = {
          fileName: item.fileName,
          mediaType: item.mediaType,
          smallUrl: item.smallUrl,
          url: item.url
        }
        this.formData.attachmentList.push(obj)
      })
    },
    giveDefaultData() {
      this.formData.judgmentDate = this.defaultData.judgmentDate
      this.formData.signDate = this.defaultData.signDate
      this.formData.agency = this.defaultData.agency
      this.formData.litigant = this.defaultData.litigant
      this.formData.remark = this.defaultData.remark
      this.formData.result = this.defaultData.result ? 1 : 0

      this.formData.attachmentList = this.defaultData.attachmentList
      this.defaultList = this.defaultData.attachmentList

      this.isDetailLoad = true
    },
    submitNew() {
      const url = '/business/case/criminal/judgment'
      const ajaxData = {
        processId: this.processId,
        caseId: this.caseId
      }
      Object.assign(ajaxData, this.formData)
      if (this.defaultData) {
        ajaxData.id = this.defaultData.id
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$patch(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.getDetail()
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      } else {
        this.$refs['formData'].validate((valid) => {
          if (valid) {
            this.isSubmit = true
            this.$post(url, ajaxData).then(res => {
              this.isSubmit = false
              if (res.code == 0) {
                this.$Message.success('操作成功')
                this.$emit('reloadProcess')
              } else {
                this.$Message.error(res.message)
              }
            })
          }
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../civilCase/caseCommon.scss';
.case-content {
  display: flex;
  .flex-class {
    flex: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/criminalCase/adjudicate/index.vue